// src/store/reducers/index.ts
import { combineReducers } from 'redux';
import menu from './menu';
import formslice from './formslice';
import categorySlice from './categorySlice';
import documentViewSlice from './documentViewSlice';
import columnSlice from './columnSlice';
import snackbar from './snackbar';
import baseApi from 'api/base';
import auth, { clearToken } from './../slice/auth-slice';
import documentListProcess from '../slice/design/documentListProcessSlice';
import masterData from '../slice/design/masterDataSlice';
import documentElements from '../slice/design/documentElementsSlice';
import upload from '../slice/design/uploadSlice'; // Import the upload slice
import taggingSlice from './taggingSlice';
import navigationSlice from './navigationSlice';
import userSettingsSlice from './userSettingsSlice';
import pageBlockerSlice from './pageBlockerSlice';
import assuranceListReducer from '../slice/navigation/assuranceListSlice';
import selectionSlice from 'store/slice/navigation/selectionSlice';
import PredectionListSlice from 'store/slice/navigation/predectionListSlice';
const combinedReducers = combineReducers({
  menu,
  snackbar,
  userSettings: userSettingsSlice,
  auth,
  documentListProcess,
  formslice,
  documentViewSlice,
  columnSlice,
  categorySlice,
  masterData,
  documentElements,
  taggingSlice,
  navigationSlice,
  upload, // Add the upload reducer
  pageBlockerSlice,
  assuranceListReducer,
  //navigationStateSlice,
  selectionSlice,
  PredectionListSlice,
  [baseApi.reducerPath]: baseApi.reducer
});

const reducers = (state: any, action: any) => {
  const clearTokenAction = clearToken().type;
  if (clearTokenAction === action.type) {
    for (let reducer in state) {
      if (reducer !== 'snackbar') state[reducer] = undefined;
    }
  }
  return combinedReducers(state, action);
};

export default reducers;
